// 性能监控
import { onFCP, onLCP, onTTFB } from 'web-vitals';
import { onCLS, onINP } from 'web-vitals/attribution';

export default defineNuxtPlugin((nuxtApp) => {
  /**
   * @TrackType sensorsdata
   * @EventType FrontendPerformance_monitor
   * @EventDesc 前端性能指标监测
   * @EventParams {
   *  xn_uuid:UUID
   *  xn_ref:refer 页面来源
   *  xn_page_url:当前页面 URL
   *  xn_page_type:页面类型
   *  xn_type:事件类型
   *  xn_value:事件值
   *  xn_delta:事件 delta
   *  xn_data:事件数据
   * }
   * @Tapd 1009440
   */
  const SDFrontendPerformanceMonitor = (params) => {
    try {
      const sdEventName = 'FrontendPerformance_monitor';
      const sdEventParams = {
        // xn_uuid: params.uuid,
        // xn_ref: params.ref,
        // xn_page_url: params.page_url,
        xn_page_type: params.page_type,
        xn_type: params.type,
        xn_value: params.value,
        xn_id: params.xn_id,
        xn_delta: params.delta,
        xn_data: params.data,
      };
      window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
    } catch (e) {
      console.log(e);
    }
  };

  // const groupId = randomString();
  const sendPoint = function (data) {
    try {
      // eslint-disable-next-line no-shadow
      // const ref = document.referrer || '';
      const pathname = location.pathname || '';
      // 上报过滤，仅上报首页、列表页、详情页、购物车页，且添加page_type字段
      const page_type =
        pathname === '/'
          ? 1
          : pathname.includes('/goods-list/')
            ? 2
            : pathname.includes('/goods-detail/')
              ? 3
              : 0;
      if (page_type === 0) return;
      const value = Math.round(data.name === 'CLS' ? data.value * 1000 : data.value);
      // const delta = Math.round(data.name === 'CLS' ? data.delta * 1000 : data.delta);
      let sendData = {};
      if (['CLS', 'INP'].includes(data.name)) {
        console.warn('perf===', data); // 输出到控制台，方便上线后查看单个详细数据
        const { attribution } = data;
        sendData = {
          name: data.name,
          value,
          // rating: data.rating,
          target:
            data.name === 'CLS' ? attribution.largestShiftTarget : attribution.interactionTarget,
        };
      }
      const params = {
        /* id格式 v3-1686536914746-5266088926298 中间数字是当前时间戳，后面是13位随机数字
         * v3是版本，后面的数字同一次会话同一个type值不变。同一次会话同样type，uuid相同，让新值覆盖老值 */
        // uuid: `${groupId}_${data.id}`,
        // ref,
        // page_url: location.href || '',
        page_type,
        type: data.name,
        value,
        xn_id: data.id,
        event_name: data.name,
        metric_value: value,
        // delta,
        data: JSON.stringify(sendData),
        // creat_time: `${Date.now()}`.substring(0, 10),
      };
      console.log('perf===', params, data);
      SDFrontendPerformanceMonitor(params);
      // nuxtApp.$api.points.performanceDmp(params);
    } catch (error) {
      console.log(error);
    }
  };
  // 参考文档 https://github.com/GoogleChrome/web-vitals
  onCLS(sendPoint);
  onFCP(sendPoint);
  onINP(sendPoint, {
    reportAllChanges: true,
  });
  onLCP(sendPoint);
  onTTFB(sendPoint);
  // 监控 domContentLoaded loaded 时间
  // window.addEventListener('load', () => {
  //   setTimeout(() => {
  //     const timing = performance.timing;
  //     const domContentLoadedTime = timing.domContentLoadedEventEnd - timing.fetchStart;
  //     const loadTime = timing.loadEventEnd - timing.fetchStart;
  //     console.warn('DOMContentLoaded 时间:', domContentLoadedTime, '毫秒');
  //     console.warn('load 时间:', loadTime, '毫秒');
  //     sendPoint({
  //       id: 'DCL',
  //       name: 'DCL',
  //       value: domContentLoadedTime,
  //       delta: domContentLoadedTime,
  //     });
  //     sendPoint({
  //       id: 'Load',
  //       name: 'Load',
  //       value: loadTime,
  //       delta: loadTime,
  //     });
  //   }, 2000);
  // });
});
